import { useEffect, useRef } from "react";
import { useContent } from "@/context/ContentContext";
import { FadeUp } from "@/components/Reveal";

const BEEHIIV_FORM_ID = "7ef0394b-96b0-4e39-a9e0-88a65c88265e";

const NewsletterForm = ({ idPrefix = "newsletter" }) => {
    const { t } = useContent();
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;
        container.innerHTML = "";
        const script = document.createElement("script");
        script.src = "https://subscribe-forms.beehiiv.com/v3/loader.js";
        script.async = true;
        script.setAttribute("data-beehiiv-form", BEEHIIV_FORM_ID);
        container.appendChild(script);
    }, []);

    return (
        <div className="stamp-frame bg-cream p-1 sm:p-8" data-testid={`${idPrefix}-form`}>
            <div className="mb-2 flex justify-center px-3 pt-3 sm:mb-4 sm:px-0 sm:pt-0">
                <p data-testid={`${idPrefix}-name`} className="inline-block -rotate-1 border-2 border-dashed border-brick px-4 py-1.5 font-display text-xl tracking-widest text-brick">
                    {t("newsletter.name", "The Clubhouse Bulletin")}
                </p>
            </div>
            <div ref={containerRef} data-testid={`${idPrefix}-beehiiv-embed`} className="min-h-[120px] w-full" />
            <p className="mt-3 text-xs text-ink/60">
                One email every so often. Unsubscribe anytime. We guard this list like the good scissors.
            </p>
        </div>
    );
};

export const NewsletterSection = ({ idPrefix = "newsletter", tone = "brick" }) => {
    const { t } = useContent();
    const bg = tone === "forest" ? "bg-forest" : "bg-brick";
    return (
        <section data-testid={`${idPrefix}-section`} className={`${bg} border-y-2 border-ink px-2 py-16 sm:px-10 sm:py-24`}>
            <div className="mx-auto max-w-4xl">
                <FadeUp>
                    <p className="font-hand text-2xl text-mustard -rotate-2">psst — the good stuff goes here first</p>
                    <h2 className="mt-1 font-display text-4xl sm:text-5xl lg:text-6xl tracking-wide text-cream">
                        {t("newsletter.heading", "Here's what you need to know.")}
                    </h2>
                    <p className="mt-3 max-w-2xl text-cream/85">
                        {t("newsletter.sub", "Opening dates, founding memberships, event announcements, and occasional clubhouse gossip.")}
                    </p>
                </FadeUp>
                <FadeUp delay={0.12} className="mt-8">
                    <div className="hard-shadow-lg">
                        <NewsletterForm idPrefix={idPrefix} />
                    </div>
                </FadeUp>
            </div>
        </section>
    );
};

export default NewsletterForm;
